import { useContext } from 'react'
import { LoginContext } from '@/context/LoginContext'

export const useLogin = () => useContext(LoginContext)
